import React from "react";
import "./../styles/globals/global.scss";

function DatesContainer({
  isEmpty,
  day,
  setDay,
  month,
  setMonth,
  year,
  setYear,
}) {
  const isLeapYear = (year) => {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  };

  const getMaxDay = (month, year) => {
    if ([4, 6, 9, 11].includes(month)) return 30;
    if (month === 2) return isLeapYear(year) ? 29 : 28;
    return 31;
  };

  const today = new Date();

  const getDayValidationRules = (month, year) => {
    const maxDay = getMaxDay(month, year);

    return (value) => {
      if (!value) return ""; // Allow empty input
      if (!/^\d+$/.test(value)) return ""; // Block non-numeric values

      // Allow leading zeros while typing
      if (value.length === 1 && value === "0") return value;

      // Parse the number to handle leading zeros correctly
      const numericValue = parseInt(value, 10);

      // Validation rules
      if (numericValue < 1) return "1";
      if (numericValue > maxDay) return String(maxDay);

      // Ensure the full date is in the future or today
      if (value.length === 2 && month && year) {
        const enteredDate = new Date(year, month - 1, numericValue);
        if (enteredDate < today.setHours(0, 0, 0, 0)) return ""; // Block past dates
      }

      return value; // Return the input as is (including leading zero)
    };
  };

  const getMonthValidationRules = (year, day) => {
    return (value) => {
      if (!value) return ""; // Allow empty input
      if (!/^\d+$/.test(value)) return ""; // Block non-numeric values

      // Allow leading zeros while typing
      if (value.length === 1 && value === "0") return value;

      // Parse the number to handle leading zeros correctly
      const numericValue = parseInt(value, 10);

      // Validation rules
      if (numericValue < 1) return "1";
      if (numericValue > 12) return "12";

      // If the month is in the past for the current year, reset it
      if (year === today.getFullYear() && numericValue < today.getMonth() + 1) {
        return String(today.getMonth() + 1);
      }

      return value; // Return the input as is (including leading zero)
    };
  };

  const getYearValidationRules = () => {
    return (value) => {
      // Allow typing only numeric values
      if (!/^\d*$/.test(value)) return value;
      if (value.length > 4) return value.slice(0, 4);

      return value;
    };
  };

  const handleYearBlur = (value) => {
    const currentYear = today.getFullYear();

    // If it's below 2025, reset on blur
    if (value && Number(value) < currentYear) {
      return String(currentYear);
    }
    return value;
  };

  return (
    <div className="control is-flex has-text-dark mb-4" style={{ gap: "10px" }}>
      <input
        className={`input inputStyle campaign-input-date centered-input mt-3 ${
          isEmpty && day === "" ? "emptyInput" : ""
        }`}
        placeholder="DD"
        value={day}
        onChange={(e) => {
          let value = e.target.value;
          value = getDayValidationRules(month, year)(value);

          setDay(value || "");
        }}
        maxLength={2}
        onInput={(e) => {
          if (e.target.value.length > 2) {
            e.target.value = e.target.value.slice(0, 2);
          }
        }}
        onBlur={() => {
          if (day === "0") {
            setDay("01");
          } else if (day) {
            setDay(getDayValidationRules(month, year)(day));
          }
        }}
      />
      <input
        className={`input inputStyle campaign-input-date centered-input mt-3 ${
          isEmpty && month === "" ? "emptyInput" : ""
        }`}
        placeholder="MM"
        value={month}
        onChange={(e) => {
          let value = e.target.value;
          value = getMonthValidationRules(year, day)(value);

          setMonth(value || "");

          // If the day is now invalid based on the new month, reset it
          if (day) {
            const maxDay = getMaxDay(value, year);
            if (day > maxDay) {
              setDay("");
            }
          }
        }}
        maxLength={2}
        onInput={(e) => {
          if (e.target.value.length > 2) {
            e.target.value = e.target.value.slice(0, 2);
          }
        }}
        onBlur={() => {
          if (month === "0") {
            setMonth("01");
          } else if (month) {
            setMonth(getMonthValidationRules(year, day)(month));
          }
        }}
      />
      <input
        className={`input inputStyle campaign-input-date centered-input mt-3 ${
          isEmpty && year === "" ? "emptyInput" : ""
        }`}
        placeholder="YYYY"
        value={year}
        onChange={(e) => setYear(getYearValidationRules()(e.target.value))}
        onBlur={() => setYear(handleYearBlur(year))} // ✅ Now it's called!
        maxLength={4}
      />
    </div>
  );
}

export default DatesContainer;
